export function handlePageChange(title, ref) {
  document.title = title;
  ref.current.tabIndex = 0;
  ref.current.focus();
}
